import {i18n} from './i18n';
import Vue from 'vue'

Vue.mixin({
    methods: {
        trans(key) {
            return i18n[key][this.$store.state.locale];
        },
        raise(qty) {
            if (qty >= 24 || qty === 0 || qty === null || typeof (qty) === 'undefined') {
                return null;
            }

            if (qty <= 23 && qty >= 19) {
                return '0,05 + ';
            }

            if (qty <= 18 && qty >= 13) {
                return '0,10 + ';
            }

            if (qty <= 12 && qty >= 7) {
                return '0,15 + ';
            }

            return '0,25 + ';
        }
    }
});